export default __webpack_public_path__ + "static/media/scb.fa29cbcd.png";